import { gql } from '@apollo/client';
import { VerifyEmailMutation, VerifyEmailMutationVariables } from '../../graphql/types';
import { client } from '../../lib/apollo';

const VERIFY_EMAIL = gql`
  mutation VerifyEmail($token: String!) {
    verifyEmail(token: $token)
  }
`;

// the page can mount more than once while the app loads, and a token only works once:
// each token is verified once per page load, and every mount gets that result
const verifications = new Map<string, Promise<boolean>>();

export const verifyEmailOnce = (token: string) => {
  let verification = verifications.get(token);
  if (!verification) {
    verification = client
      .mutate<VerifyEmailMutation, VerifyEmailMutationVariables>({
        mutation: VERIFY_EMAIL,
        variables: { token },
      })
      .then(({ data }) => Boolean(data?.verifyEmail));
    verifications.set(token, verification);
  }
  return verification;
};
